import VideoModal from '@/app/(content)/media/VideoModal'
import clsx from 'clsx'
import { useEffect, useRef, useState } from 'react'
import styles from './index.module.css'

export default function MdTestimonialCard({
  testimonial,
  index,
  selectedTestimonialIndex,
  toggleTestimonial,
}) {
  const [isPlaying, setIsPlaying] = useState(false)
  const videoRef = useRef(null)
  const cardRef = useRef(null)
  const [calculatedWidth, setCalculatedWidth] = useState('100%')
  const [openModals, setOpenModals] = useState({})
  const toggleModal = (index) => {
    setOpenModals((prevOpenModals) => ({
      ...prevOpenModals,
      [index]: !prevOpenModals[index],
    }))
    setIsPlaying(!isPlaying)
  }

  useEffect(() => {
    const videoElement = videoRef.current

    const handleVideoEnd = () => {
      setIsPlaying(false)
    }

    if (videoElement) {
      videoElement.addEventListener('ended', handleVideoEnd)
    }

    return () => {
      if (videoElement) {
        videoElement.removeEventListener('ended', handleVideoEnd)
      }
    }
  }, [])

  useEffect(() => {
    if (selectedTestimonialIndex === index && cardRef.current) {
      const parentWidth = cardRef.current.parentNode.offsetWidth
      setCalculatedWidth(parentWidth)
    }
  }, [selectedTestimonialIndex, index])

  return (
    <div
      onClick={() => {
        if (selectedTestimonialIndex !== index) {
          toggleTestimonial(index)
        } else {
          toggleModal(index)
          setIsPlaying(true)
        }
      }}
      ref={cardRef}
      className={clsx(
        'cursor-pointer relative flex flex-col justify-end gap-8 bg-[#F8F9FCBF] bg-cover rounded-2xl px-8 py-6 h-[441px] max-h-[441px] xl:max-h-[441px] transition-[width] duration-500 ease',
      )}
      style={{
        width: selectedTestimonialIndex === index ? calculatedWidth : 184,
        minWidth: selectedTestimonialIndex !== index && 184,
        background: `url(${testimonial?.src}) no-repeat center center`,
        backgroundSize: 'cover',
      }}
    >
      {selectedTestimonialIndex !== index && (
        <div className={styles.overlay}></div>
      )}
      {selectedTestimonialIndex === index && (
        <div className="absolute w-full left-0 top-0 h-full rounded-2xl">
          {!isPlaying && (
            <div className="absolute inset-0 flex items-center justify-center cursor-pointer">
              <svg
                width="98"
                height="98"
                viewBox="0 0 98 98"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter0_bi_6187_33305)">
                  <circle
                    cx="49"
                    cy="48.9956"
                    r="48"
                    fill="black"
                    fill-opacity="0.25"
                  />
                  <circle
                    cx="49"
                    cy="48.9956"
                    r="48.5"
                    stroke="url(#paint0_linear_6187_33305)"
                    stroke-opacity="0.2"
                  />
                </g>
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M66.496 51.59C68.4975 50.4355 68.4975 47.547 66.496 46.3926L40.4989 31.3975C38.4989 30.2439 36 31.6873 36 33.9962V63.9863C36 66.2952 38.4989 67.7386 40.4989 66.585L66.496 51.59Z"
                  fill="white"
                />
                <defs>
                  <filter
                    id="filter0_bi_6187_33305"
                    x="-20"
                    y="-20.0044"
                    width="138"
                    height="138"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="10" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_6187_33305"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_6187_33305"
                      result="shape"
                    />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feMorphology
                      radius="1.46045"
                      operator="dilate"
                      in="SourceAlpha"
                      result="effect2_innerShadow_6187_33305"
                    />
                    <feOffset dx="-0.730227" dy="0.730227" />
                    <feGaussianBlur stdDeviation="0.365113" />
                    <feComposite
                      in2="hardAlpha"
                      operator="arithmetic"
                      k2="-1"
                      k3="1"
                    />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.35 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="shape"
                      result="effect2_innerShadow_6187_33305"
                    />
                  </filter>
                  <linearGradient
                    id="paint0_linear_6187_33305"
                    x1="85.7742"
                    y1="7.57625"
                    x2="49"
                    y2="96.9956"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" />
                    <stop offset="1" stop-color="white" stop-opacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          )}

          <div
            style={{
              background: true
                ? 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #0D0E0E 100%)'
                : 'transparent',
            }}
            className="absolute bottom-0 left-0 right-0 text-white p-4 rounded-b-lg flex items-center justify-between"
          >
            <div className="text-animate">
              {' '}
              <h3 className="text-lg">{testimonial.title}</h3>
            </div>
          </div>
        </div>
      )}

      {openModals[index] && testimonial.videoUrl && (
        <VideoModal
          videoUrl={testimonial.videoUrl}
          open={openModals[index]}
          setOpen={() => toggleModal(index)}
        />
      )}
    </div>
  )
}
